'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Button } from '../button/button.component.js';
import { Icon } from '../icon/icon.component.js';

let s = {
    accessibleText: t.string
}, n = [
    'accessibleText'
];
const PriceBarPriceInfo = renderWithRef('PriceBarPriceInfo', s, (r, c)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: c,
        classNames: new Set([
            'swan-price-bar-price-info'
        ]),
        props: r,
        propKeysToRemove: n,
        children: jsx(Button, {
            skin: "unstyled",
            children: jsx(Icon, {
                alt: r.accessibleText || '',
                iconType: "info",
                size: "16p"
            })
        })
    }));

export { PriceBarPriceInfo };
